import Breadcrumb from "@/common/Breadcrumb";
import HeaderOne from "@/layouts/headers/HeaderOne";
import Wrapper from "@/layouts/Wrapper";
import { useI18n } from "@/common/I18nProvider";
import CtaHomeOne from "../homes/home-1/CtaHomeOne";
import FooterOne from "@/layouts/footers/FooterOne";
import ServicesArea from "./ServicesArea";

export default function Services() {
  const { messages } = useI18n();
  const servicesLabel = messages.nav?.services || "Services";

  return (
    <Wrapper>
      <HeaderOne />
      <div id="smooth-wrapper">
        <div id="smooth-content">
          <Breadcrumb title={servicesLabel} pageLink={servicesLabel} />
          <ServicesArea />          
          <CtaHomeOne />
          <FooterOne />
        </div>
      </div>
    </Wrapper>
  )
}